/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Image from 'types/models/Image';

export const parseImages = (images: any[]): Image<any>[] => {
  return images.map((image) => parseImage(image));
};

export const parseImage = (data: any): Image<any> => ({
  type: data.id,
  path: data.path,
});

const getBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result as string;
      resolve(result.split(',')[1]); // => "data:image/...;base64,"
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const loadImage = async (image: Image<any>) => {
  if (!image.path) return;
  const base64Response = await getBase64(image.path);
  const dataURL = `data:image/jpeg;base64,${base64Response}`;
  const fetchResponse = await fetch(dataURL);
  const blob = await fetchResponse.blob();
  image.preview = dataURL;
  image.data = blob;
};

export const loadImages = async (images: Image<any>[]): Promise<void> => {
  for (const image of images) {
    try {
      await loadImage(image);
    } catch (error) {
      console.error('Error loading image:', error);
    }
  }
};
